import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { PERMISSION_IMPORTED_RECORD } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import ImportRecord from '../../components/ImportRefuelings/ImportRecord';

export const Route = createFileRoute('/_authenticated/expenses_import/expense/import')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_IMPORTED_RECORD, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.expense/import',
        suffix: 'menu.expenseImports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ExpenseImportRecordRoute,
});

function ExpenseImportRecordRoute() {
  const location = useLocation();
  const showTable =
    !location.pathname.includes('/expenses_import/expense/import/record') &&
    !location.pathname.includes('/expenses_import/wizard');
  return (
    <>
      {showTable && <ImportRecord />}
      <Outlet />
    </>
  );
}
